import emailjs from '@emailjs/browser';

// In React, process.env è già disponibile
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

console.log('EmailJS Config:', { 
    PUBLIC_KEY, 
    SERVICE_ID, 
    TEMPLATE_ID 
});

// Verifica che le variabili siano caricate
if (!PUBLIC_KEY || !SERVICE_ID || !TEMPLATE_ID) {
    console.error('EmailJS configuration missing:', {
        PUBLIC_KEY: !!PUBLIC_KEY,
        SERVICE_ID: !!SERVICE_ID,
        TEMPLATE_ID: !!TEMPLATE_ID
    });
}

// Inizializza EmailJS
emailjs.init(PUBLIC_KEY);

export const EMAIL_CONFIG = {
    SERVICE_ID,
    TEMPLATE_ID,
    PUBLIC_KEY
}; 